module.exports = __webpack_public_path__ + "img/whatsapp.13f695ce.svg";